module.exports = __webpack_public_path__ + "static/media/washingtonpost-logo.97dd635b.svg";